import { useState } from "react";
import { AiOutlineMessage } from "react-icons/ai";
import { BiHomeCircle, BiBrain } from "react-icons/bi";
import { CgProfile } from "react-icons/cg";
import { GiGearHammer } from "react-icons/gi";

import "./nav.css";
import { Sections } from "../../App";

const Nav = () => {
  const [activeNavButton, setActiveNavButton] = useState<string>("#header");

  const isActive = (buttonHref: string) =>
    // buttonHref === activeNavButton ? "active" : "";
    buttonHref === activeNavButton ? "" : "";

  return (
    <nav>
      <a
        href={`#${Sections.HEADER}`}
        data-hover="Home"
        className={isActive("#header")}
        onClick={() => setActiveNavButton("#header")}
      >
        <BiHomeCircle />
      </a>

      <a
        href={`#${Sections.ABOUT_ME}`}
        data-hover="About Me"
        className={isActive("#about-me")}
        onClick={() => setActiveNavButton("#about-me")}
      >
        <CgProfile />
      </a>

      <a
        href={`#${Sections.SKILLS}`}
        data-hover="Skills"
        className={isActive("#skills")}
        onClick={() => setActiveNavButton("#skills")}
      >
        <BiBrain />
      </a>

      <a
        href={`#${Sections.EXPERIENCE}`}
        data-hover="My Experience"
        className={isActive("#experience")}
        onClick={() => setActiveNavButton("#experience")}
      >
        <GiGearHammer />
      </a>

      <a
        href={`#${Sections.CONTACT}`}
        data-hover="Contact Me"
        className={isActive("#contact")}
        onClick={() => setActiveNavButton("#contact")}
      >
        <AiOutlineMessage />
      </a>
    </nav>
  );
};

export default Nav;
